import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlSegment } from '@angular/router';

const commonRoutes: Routes = [
  {
    path: 'terms-of-us',
    title: 'termsOfUsePage.titleTab',
    loadComponent: () => import('@public-page/pages/static').then((mod) => mod.TermsOfUsComponent),
  },
  {
    path: 'imprint',
    title: 'imprintPage.titleTab',
    loadComponent: () => import('@public-page/pages/static').then((mod) => mod.ImprintComponent),
  },
  {
    path: '**',
    title: 'notFoundPage.titleTab',
    data: {
      backButtonTitle: 'notFoundPage.backButton',
      backButtonRoute: { path: ['public'] }
    },
    loadComponent: () => import('@public-page/pages/static').then((mod) => mod.NotFoundComponent),
  }
];

const routesForCustomDomain: Routes = [
  {
    path: '',
    children: [
      {
        path: 'public',
        loadChildren: () =>
          import('@public-page/modules/company-page/company-page.module').then((mod) => mod.CompanyPageModule),
      },
      {
        path: 'booking',
        title: 'bookingPage.titleTab',
        loadChildren: () => import('@public-page/modules/booking/booking.module').then((mod) => mod.BookingModule),
      },
      {
        path: 'error/:code',
        title: 'errorPage.titleTab',
        loadComponent: () => import('@public-page/pages/static').then((mod) => mod.ErrorComponent),
      },
      {
        path: '',
        loadChildren: () =>
          import('@public-page/modules/authorization/authorization.module').then((mod) => mod.AuthorizationModule),
      },
      ...commonRoutes
    ],
  },
];

const routesForOwnDomain: Routes = [
  {
    matcher: (url) => {
      if (url.length > 1 && url[0].path.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/gm)) {
        return {
          consumed: url.length === 1 ? url : url.slice(0, 1),
          posParams: {
            companyUuid: new UrlSegment(url[0].path, {}),
          },
        };
      }

      return null;
    },
    children: [
      {
        path: 'public',
        loadChildren: () =>
          import('@public-page/modules/company-page/company-page.module').then((mod) => mod.CompanyPageModule),
      },
      {
        path: 'booking',
        title: 'bookingPage.titleTab',
        loadChildren: () => import('@public-page/modules/booking/booking.module').then((mod) => mod.BookingModule),
      },
      {
        path: 'error/:code',
        title: 'errorPage.titleTab',
        loadComponent: () => import('@public-page/pages/static').then((mod) => mod.ErrorComponent),
      },
      {
        path: '',
        loadChildren: () =>
          import('@public-page/modules/authorization/authorization.module').then((mod) => mod.AuthorizationModule),
      },
      ...commonRoutes
    ],
  },
];

const routes: Routes = [
  ...routesForOwnDomain,
  ...routesForCustomDomain
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
